import { render, staticRenderFns } from "./OrganizationData.vue?vue&type=template&id=cd8ebb10&"
import script from "./OrganizationData.vue?vue&type=script&lang=js&"
export * from "./OrganizationData.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports